import axios from 'axios';
import { SERVER_ENDPOINT, CLIENT_ID, CLIENT_SECRET } from '../Constants';

function getBlogPosts({
  query,
  author,
  category,
  tag,
  sort,
  page,
  pageSize,
} = {}) {
  const url = 'api/blog/post/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    params: {
      query,
      author,
      category,
      tag,
      sort,
      page,
      page_size: pageSize,
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getBlogPostByIdOrSlug(id_or_slug) {
  const url = `api/blog/post/${id_or_slug}/`;

  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getAllBlogAuthors() {
  const url = 'api/blog/authors/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getAllBlogCategories() {
  const url = 'api/blog/categories/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

function getAllBlogTags() {
  const url = 'api/blog/tags/';
  return axios({
    method: 'get',
    url,
    baseURL: SERVER_ENDPOINT,
    timeout: '10000',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    data: {
      client_id: CLIENT_ID,
      client_secret: CLIENT_SECRET,
    },
  });
}

export {
  getBlogPosts,
  getBlogPostByIdOrSlug,
  getAllBlogAuthors,
  getAllBlogCategories,
  getAllBlogTags,
};
